import AbstractEditWidget from "../widgets/AbstractEditWidget";
import { Checkbox } from "../../../lib/ui/controls/Checkbox";
import { DropdownSelection } from "../widgets/DropdownSelection";
import { MethodPackManager } from "../../MethodPackManager";
import lodash from "lodash";
import { C } from "../../../lib/ui/constructors";
import { util } from "../../../lib/util/util";
var span = C.span;
var copyUpdate = util.copyUpdate;
export class DisplayedRouteFilterEdit extends AbstractEditWidget {
    constructor() {
        super();
    }
    setValue(v) {
        if (!v)
            v = { type: "none" };
        return super.setValue(v);
    }
    async render() {
        this.empty();
        const filter = this.get();
        const group = new Checkbox.Group([
            { value: "none", button: new Checkbox("None") },
            { value: "favourites", button: new Checkbox("Preferred") },
            { value: "pack", button: new Checkbox("Method Pack") },
        ])
            .setValue(filter.type)
            .onChange(async (kind) => {
            this.method_dropdown.setEnabled(kind == "pack");
            const default_pack = (await MethodPackManager.instance().all())[0];
            this.commit(copyUpdate(this.get(), filter => {
                filter.type = kind;
                if (kind == "pack") {
                    filter.local_pack_id ?? (filter.local_pack_id = default_pack.local_id);
                }
            }));
        });
        this.append(...group.checkboxes());
        this.method_dropdown = new DropdownSelection({
            type_class: {
                toHTML(v) {
                    if (v)
                        return span(`${lodash.capitalize(v.type)}: ${v.name}`);
                    else
                        return span("None");
                }
            },
        }, await MethodPackManager.instance().all())
            .setValue(await MethodPackManager.instance().getPack(filter.local_pack_id))
            .setItems(async () => await MethodPackManager.instance().all())
            .setEnabled(filter.type == "pack")
            .onSelection(pack => {
            this.commit(copyUpdate(this.get(), filter => {
                filter.local_pack_id = pack.local_id;
            }));
        })
            .appendTo(this);
    }
}
